import { defineMessages, useIntl } from 'react-intl';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import {
  isExternalHref,
  resolveLinkHref,
  type LinkFieldValue,
} from '../../../helpers/blocks';
import arrowRightSVG from '../../../icons/arrow-right.svg';

const messages = defineMessages({
  defaultTitle: {
    id: 'nextSteps.default.title',
    defaultMessage: 'Next Steps',
  },
  placeholder: {
    id: 'nextSteps.placeholder',
    defaultMessage: 'Add the milestones in the sidebar…',
  },
});

export type NextStepItem = { period?: string; description?: string };

export type NextStepsData = {
  title?: string;
  intro?: string;
  items?: NextStepItem[];
  linkLabel?: string;
  link?: LinkFieldValue;
};

type NextStepsBodyProps = {
  data: NextStepsData;
  isEditMode?: boolean;
};

const NextStepsBody = ({ data, isEditMode }: NextStepsBodyProps) => {
  const intl = useIntl();
  const items = (data.items || []).filter(
    (item) => item.period || item.description,
  );
  const href = resolveLinkHref(data.link);
  const linkLabel = data.linkLabel?.trim();
  const showLink = Boolean(linkLabel && (href || isEditMode));

  if (items.length === 0 && !isEditMode) return null;

  return (
    <div className="block-next-steps">
      <h2 className="next-steps__title">
        {data.title || intl.formatMessage(messages.defaultTitle)}
      </h2>

      <div className="next-steps__content">
        {data.intro && <p className="next-steps__intro">{data.intro}</p>}

        {items.length > 0 ? (
          <ul className="next-steps__items">
            {items.map((item, i) => (
              <li className="next-steps__item" key={i}>
                {item.period && (
                  <h3 className="next-steps__period">{item.period}</h3>
                )}
                {item.description && (
                  <p className="next-steps__description">{item.description}</p>
                )}
              </li>
            ))}
          </ul>
        ) : (
          <p className="next-steps__placeholder">
            {intl.formatMessage(messages.placeholder)}
          </p>
        )}

        {showLink &&
          (isEditMode ? (
            // No editor o link não navega: o clique seleciona o bloco.
            <span className="next-steps__link">
              {linkLabel}
              <Icon name={arrowRightSVG} size="20px" ariaHidden />
            </span>
          ) : (
            <a
              className="next-steps__link"
              href={href}
              {...(isExternalHref(href) && {
                target: '_blank',
                rel: 'noopener noreferrer',
              })}
            >
              {linkLabel}
              <Icon name={arrowRightSVG} size="20px" ariaHidden />
            </a>
          ))}
      </div>
    </div>
  );
};

export default NextStepsBody;
